// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3UH0U","row":"ProcedureTreatmentSummary_row__jCw5P"};